import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import Snippets from './Snippets';  // component for listing snippets

function LanguageRoute({ supportedLanguages }) {
    // Get language from the URL
    const { language: currentLanguage } = useParams();

    // Extract the names from the currentLanguages array
    const supportedLanguageNames = supportedLanguages.map(lang => lang.name.toLowerCase());

    // State for fetched snippets
    const [snippets, setSnippets] = useState([]);

    // Check if the language is supported
    const isSupportedLanguage = supportedLanguageNames.includes(currentLanguage?.toLowerCase());

    // Find the documentationURL for the current language
    const currentLanguageData = supportedLanguages.find(
        lang => lang.name.toLowerCase() === currentLanguage?.toLowerCase()
    );
    const documentationURL = currentLanguageData?.documentationURL;

    // Fetch snippets when the language changes (if the language is valid)
    useEffect(() => {
        if (isSupportedLanguage) {
            const fetchSnippets = async (lang) => {
                const url = lang
                    ? `https://api.jimmybauduin.com/snippets?language=${lang}`
                    : 'https://api.jimmybauduin.com/snippets';

                try {
                    const response = await axios.get(url);
                    setSnippets(response.data.snippets);
                } catch (error) {
                    console.error('Error fetching snippets:', error);
                }
            };

            fetchSnippets(currentLanguage);
        }
    }, [currentLanguage, isSupportedLanguage]);    

    // Redirect if the language is not supported
    if (!isSupportedLanguage) {
        return <Navigate to="/" replace />;
    }

    // Pass the fetched snippets to the Snippets component
    return <Snippets snippets={snippets} documentationURL={documentationURL} />;
}

export default LanguageRoute;
